import { Icon } from '@rbilabs/universal-components';

import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { useLocale } from 'state/intl';
import { ILocalizedMenuEntry, IndexedMenu } from 'state/unified-menu/types';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { SlotsSelections } from '../../product-wizard/types';
import { computeComboSodium } from '../../product-wizard/utils';
const SODIUM_LIMIT = 2300;

export const OverSodiumLimitWarning = () => {
  const { region } = useLocale();

  const { indexedMenu } = useUnifiedMenuContext();
  const { selectedProduct, slotsSelections } = useProductWizardContext();

  if (region !== 'US') {
    return null;
  }

  return hasExcessSodium(indexedMenu, selectedProduct, slotsSelections) ? (
    <Icon variant="sodiumFlag" testID="sodium-flag" size={{ base: '20px', md: '26px' }} />
  ) : null;
};

function hasExcessSodium(
  menu: IndexedMenu<ILocalizedMenuEntry>,
  selectedProduct: ILocalizedMenuEntry,
  slotsSelections: SlotsSelections
) {
  let totalSodium = 0;

  if (selectedProduct.type === 'ITEM') {
    totalSodium = selectedProduct.nutrition?.nutrients?.sodium ?? 0;
  } else if (selectedProduct.type === 'COMBO') {
    totalSodium = computeComboSodium(menu, selectedProduct, slotsSelections);
  }

  return totalSodium > SODIUM_LIMIT;
}
